import { Button } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'


function ErrorPage() {
  return (
    <>
      <div class="verticalcenter">
        <div class="container">
          <div id="notfound" class="text-center ">
            <h1>😮</h1>
            <h2>Oops! Page Not Be Found</h2>
            <p>Sorry but the page you are looking for does not exist.</p>
            <Link to={'/'}><Button style={{backgroundColor:'#18231d',color:'white',textTransform:'capitalize'}}>Back to homepage</Button></Link>
          </div>
        </div>
      </div>
    </>
  )
}

export default ErrorPage
